export const postOrderRow = () => (dispatch) => {
  dispatch(setUserLoading());
  Axios.get(
    `/api/v1/orders/${this.state.id}/order_rows/${this.state.suppliers_id}/supplyings`
  )
    .then((res) => {
      dispatch({
        type: GET_DOCUMENT_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const selectedOrderRows =
  (id, order_id) => async (dispatch, getState) => {
    try {
      const update_order_row = (e) => {
        return {
          ...e,
          selected: !e.selected,
        };
      };
      const state = getState();
      let { order_rows } = state.orders;
      order_rows = order_rows.map((e) => {
        if (e.id == id) {
          return update_order_row(e);
        }
        return e;
      });
      if (!order_id) {
        return dispatch({
          type: "SET_ORDER_ROWS",
          payload: order_rows,
        });
      } else {
        let { orders } = state.orders;
        orders = orders.map((e) => {
          if (e.id == order_id) {
            return {
              ...e,
              order_rows: e.order_rows.map((or) => {
                if (or.id == id) {
                  return update_order_row(or);
                }
                return or;
              }),
            };
          }
          return e;
        });
        return dispatch({
          type: "SET_ORDER_ROWS_WITH_ORDER",
          payload: { order_rows, orders },
        });
      }
      console.log(id);
    } catch (err) {
      console.log("Error: ", err);
    }
  };

export const deleteOrderRow = () => (dispatch) => {
  dispatch(setUserLoading());
  Axios.delete(
    `/api/v1/orders/${this.state.id}/order_rows/${id_order_row}/supplyings/${id}`
  )
    .then((res) => {
      dispatch({
        type: GET_DOCUMENT_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};